import { from as observableFrom,  Observable,  BehaviorSubject} from 'rxjs';
import { tap, mergeMap, map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api';
import * as moment from "moment";
import { DigestItemRequestModel } from '../model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from './user.service';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class DigestService {
    digestUpdates = new BehaviorSubject<object>(null);
    path: string = '/ws/user';

    constructor(private api: ApiService,
                private tenantService: TenantService, 
                private userService: UserService,
                private snackBar: MatSnackBar){}

    getDigestConfigurationsForUser(userId: String, createEnabled = false):Observable<any> {
        return this.api.get(this.path + '/' + userId + '/digestConfigurations')
        .pipe(
            mergeMap(digests => {
                if(!digests.length){
                    return this.tenantService.getCurrentTenant()
                    .pipe(
                        flatMap((tenant: {settings}) => {
                            const title = tenant.settings.defaultTitle && tenant.settings.defaultTitle.length ? tenant.settings.defaultTitle : 'My Personal Digest'; 
                            const digest = {
                                content: {},
                                title,
                                schedule: {
                                    scheduleMode: 'RECURRING',
                                    start: '1900-01-01T00:00:00.000Z',
                                    timeZone: this.userService.getCurrentUser().timeZone || 'US/Pacific',
                                    freq: 'DAILY',
                                    byday: [],
                                    interval: 1,
                                    sendHour: new Date().getHours(),
                                    sendMinute: 0,
                                    enabled: createEnabled
                                }
                            };
                            if (tenant.settings.defaultDigestSchedule) {
                                ['timeZone', 'freq', 'interval', 'sendHour', 'sendMinute'].forEach(attr => {
                                    digest.schedule[attr] = tenant.settings.defaultDigestSchedule[attr] || digest.schedule[attr];     
                                });
                                if (digest.schedule.freq === 'WEEKLY') {
                                    digest.schedule.byday = tenant.settings.defaultDigestSchedule.byday || ['MO'];
                                }
                            } 
                            return this.api.post(this.path + '/' + userId + '/digestConfigurations', digest);
                        }),
                        map(digest => {
                            digest.streams = [];
                            return [digest]
                        })
                    );
                }else{
                    return observableFrom([digests]);
                }
            })
        );
    };

    putDigestConfigurationsForUser(userId: String, digest: any):Observable<any> {
        const target = Object.assign({}, digest);
        const send = moment(digest.schedule.sendTime);
        if(target.schedule.sendDay && target.schedule.freq === 'WEEKLY'){
            target.schedule.byday = Array.isArray(target.schedule.sendDay) ? target.schedule.sendDay : [target.schedule.sendDay];
        }
        target.schedule.sendHour = send.hours();
        target.schedule.sendMinute = send.minutes();
        return this.api.put(this.path + '/' + userId + '/digestConfigurations/' + target.id, target)
        .pipe(
            tap(digest => {
                this.digestUpdates.next(digest);
                this.snackBar.open(`Notificaction changes saved.`, 'OK', { duration: 2000 });
            })
        );
    };

    searchItems(request: DigestItemRequestModel): Observable<any> {
        return this.api.get(
            `${this.path}/${request.userId}/digestConfigurations/${request.digestId}/items`,
            request.asURLSearchParams()
        );
    }

    previewUrl(digestConfigurationId, userId, extra?) {
        return `/ws/user/${userId}/digestConfigurations/${digestConfigurationId}/preview${extra ? extra : ''}`;
    }
    unsubscribe(userId: string): Observable<any> {
        return this.api.post('/ws/ua/digest/unsubscribe', { userId });
    }
}
